import React from "react";
import { colors } from "../../constants/colors";
import technology from "../../images/technology.png";
export const OurInvention = () => {
  return (
    <section
      // data-aos="zoom-in-up"
      className="team-banner container-fluid px-0"
      id="team-banner"
      style={{ backgroundColor: colors.gencLightBlue }}
    >
      <div className="row no-gutters">
        <div className="col-xs-12 col-sm-12 col-md-7">
          <img src={technology} alt="Angelo-Technology" />
        </div>
        <div
          className="team-banner-details d-flex justify-content-center align-items-center col-xs-12 text-center col-sm-12 col-md-5 text-md-left"
          data-aos="fade-left"
          data-aos-delay="250"
        >
          <div className="p-5">
            <h1 style={{ color: colors.gencBlue }}>Our Invention</h1>
            <p style={{ color: colors.gencBlack }}>
              The way how to make the Hybrid-Blockchain Protocol work in
              practice requires us to leverage a Blockchain technology called
              Hyperledger. Our ‘hybrid’ practice enables storing and processing
              a large file efficiently without high cost compared to the only
              pure blockchain solution. We package the technology into
              independent units called Angelo Engines and then ship the engines
              with support from trained DevOps engineers for medium-size
              startups and large organizations. With these efforts, we offer a
              helping hand together with other teams and organizations
              preventing large-scale cyber wars from worsening.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
